module.exports = __webpack_public_path__ + "media/images/global/icons/gift-59444e02fb99e2ce67580734881c23c3.svg";